export default __webpack_public_path__ + "static/media/expressable-logo.f7d915bd.svg";